(() => {
  const root = document.querySelector("[data-showrooms]");
  if (!root) return;

  const initListSlider = () => {
    const list = root.querySelector(".showrooms-list");
    const controls = root.querySelector(".showrooms-list-controls");
    if (!list || !controls) return;

    const previous = controls.querySelector(".showrooms-list-prev");
    const next = controls.querySelector(".showrooms-list-next");
    const position = controls.querySelector(".showrooms-list-position");
    const mobile = window.matchMedia("(max-width: 991px)");
    let index = 0;
    let frame = null;
    const visibleItems = () => Array.from(list.children).filter((item) => !item.classList.contains("hidden"));

    const update = () => {
      const items = visibleItems();
      controls.hidden = !mobile.matches || items.length < 2;
      if (!mobile.matches || !list.clientWidth) return;

      const left = list.getBoundingClientRect().left;
      index = items.reduce((nearest, item, current) => {
        return Math.abs(item.getBoundingClientRect().left - left) <
          Math.abs(items[nearest].getBoundingClientRect().left - left) ? current : nearest;
      }, 0);
      position.textContent = items.length ? `${index + 1} / ${items.length}` : "";
      previous.disabled = index === 0;
      next.disabled = index >= items.length - 1;
    };

    const goTo = (target, smooth = true) => {
      const items = visibleItems();
      const item = items[Math.max(0, Math.min(target, items.length - 1))];
      if (!mobile.matches || !item || !list.clientWidth) return;
      const left = item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
      list.scrollTo({
        left,
        behavior: smooth && !window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "smooth" : "instant",
      });
    };

    previous.addEventListener("click", () => goTo(index - 1));
    next.addEventListener("click", () => goTo(index + 1));
    list.addEventListener("scroll", () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    list.addEventListener("keydown", (event) => {
      if (event.target !== list || !mobile.matches) return;
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      goTo(index + (event.key === "ArrowRight" ? 1 : -1));
    });
    root.addEventListener("showrooms:search", () => {
      index = 0;
      goTo(0, false);
      update();
    });
    root.addEventListener("showrooms:view", () => requestAnimationFrame(update));
    window.addEventListener("resize", () => {
      goTo(index, false);
      update();
    });
    update();
  };

  const initInteractions = () => {
    if (root.dataset.showroomsInteractionsInitialized === "true") return;

    if (typeof ShowroomsTabs !== "undefined") new ShowroomsTabs(root);
    if (typeof ShowroomsSearch !== "undefined") new ShowroomsSearch(root);
    initListSlider();
    root.dataset.showroomsInteractionsInitialized = "true";
  };

  const initMap = () => {
    if (
      root.dataset.showroomsMapInitialized === "true" ||
      typeof ShowroomsMap === "undefined" ||
      !Array.isArray(window.showroomsData) ||
      !window.maplibregl?.Map
    ) {
      return;
    }

    new ShowroomsMap(root, window.showroomsData);
    root.dataset.showroomsMapInitialized = "true";
  };

  const initPage = () => {
    initInteractions();
    initMap();
  };

  window.initIwcShowroomsMap = initMap;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPage, { once: true });
  } else {
    initPage();
  }
})();
